import { FARE_CLASSES_SORTING_ORDER } from "@config/config";

export const productPricesVariable = (availablePrices, products) => {
  const _products = availablePrices.map((product) => {
    return {
      ProductId: product.ProductId,
      OutboundJourney: product.OutboundLegs.map((item) => {
        const IsBusinessClass = products.OutboundJourneys[0].Legs[
          item.OrderNumber - 1
        ].SeatInfo.filter((pass) => product.ProductId === pass.ProductId)[0]
          ?.IsBusinessClass;

        let LegPriceId = item.Prices.filter(
          (price) =>
            price.IsCampaign && price.IsBusinessClass === IsBusinessClass,
        )[0]?.PriceId;

        if (!LegPriceId) {
          LegPriceId = item.Prices.filter(
            (price) =>
              !price.IsCampaign && price.IsBusinessClass === IsBusinessClass,
          )[0]?.PriceId;
        }
        return {
          LegOrderNumber: item.OrderNumber,
          LegPriceId,
        };
      }),
      ...(products.InboundJourneys?.length
        ? {
            InboundJourney: product.InboundLegs.map((item) => {
              const IsBusinessClass = products.InboundJourneys[0].Legs[
                item.OrderNumber - 1
              ].SeatInfo.filter(
                (pass) => product.ProductId === pass.ProductId,
              )[0]?.IsBusinessClass;

              let LegPriceId = item.Prices.filter(
                (price) =>
                  price.IsCampaign && price.IsBusinessClass === IsBusinessClass,
              )[0]?.PriceId;

              if (!LegPriceId) {
                LegPriceId = item.Prices.filter(
                  (price) =>
                    !price.IsCampaign &&
                    price.IsBusinessClass === IsBusinessClass,
                )[0]?.PriceId;
              }

              return {
                LegOrderNumber: item.OrderNumber,
                LegPriceId,
              };
            }),
          }
        : {}),
    };
  });

  return _products;
};

// check if there is a multi floor occupied bus
export const checkHasMultiFloorOccupiedBus = (products) => {
  try {
    const legs = products.OutboundJourneys[0].Legs.concat(
      products.InboundJourneys?.[0]?.Legs || [],
    );

    return legs.some((leg) => {
      if (leg.SeatPlan.Buses[0].Floors.length > 1) {
        return leg.SeatPlan.Buses[0].Floors.every((floor) =>
          floor.SeatRows.some((row) =>
            row.Seats.some((seat) => !!seat.ProductGuid),
          ),
        );
      }
      return false;
    });
  } catch (e) {
    console.log("checkHasMultiFloorOccupiedBus", e);
    return false;
  }
};

// get floor number with occupied seats (prioritizing floor 2)
export const getOccupiedFloorNumber = (
  products,
  isOutbound = true,
  activeBus = 0,
) => {
  try {
    // Get legs for specified direction only
    const legs = isOutbound
      ? products.OutboundJourneys?.[0]?.Legs || []
      : products.InboundJourneys?.[0]?.Legs || [];

    // Check if the requested bus index exists
    if (!legs[activeBus]) {
      return null;
    }

    const bus = legs[activeBus].SeatPlan.Buses[0];

    // Check if it's a two-floor bus
    if (bus.Floors.length > 1) {
      // First check floor 2 (index 1)
      if (
        bus.Floors[1].SeatRows.some((row) =>
          row.Seats.some((seat) => !!seat.ProductGuid),
        )
      ) {
        return 2;
      }

      // Then check floor 1 (index 0)
      if (
        bus.Floors[0].SeatRows.some((row) =>
          row.Seats.some((seat) => !!seat.ProductGuid),
        )
      ) {
        return 1;
      }
    }

    return null; // Return null if no two-floor bus with occupied seats is found
  } catch (e) {
    console.log("getOccupiedFloorNumber", e);
    return null;
  }
};

export const sortProductsAndSeats = (products) => {
  try {
    if (!products?.OutboundJourneys?.[0]?.Products) {
      return products;
    }

    const referenceProducts = [...products.OutboundJourneys[0].Products].sort(
      (a, b) => {
        const indexA = FARE_CLASSES_SORTING_ORDER.indexOf(a.RequestedFareClass);
        const indexB = FARE_CLASSES_SORTING_ORDER.indexOf(b.RequestedFareClass);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      },
    );

    const productIdOrder = referenceProducts.map((p) => p.ProductId);

    const sortByProductId = (array) => {
      if (!Array.isArray(array)) return array;

      return [...array].sort((a, b) => {
        const indexA = productIdOrder.indexOf(a.ProductId);
        const indexB = productIdOrder.indexOf(b.ProductId);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      });
    };

    const sortedProducts = JSON.parse(JSON.stringify(products));

    sortedProducts.OutboundJourneys[0].Products = sortByProductId(
      sortedProducts.OutboundJourneys[0].Products,
    );

    if (sortedProducts.OutboundJourneys[0].Legs) {
      sortedProducts.OutboundJourneys[0].Legs.forEach((leg) => {
        if (leg.SeatInfo) {
          leg.SeatInfo = sortByProductId(leg.SeatInfo);
        }
      });
    }

    if (sortedProducts.InboundJourneys?.[0]) {
      sortedProducts.InboundJourneys[0].Products = sortByProductId(
        sortedProducts.InboundJourneys[0].Products,
      );

      if (sortedProducts.InboundJourneys[0].Legs) {
        sortedProducts.InboundJourneys[0].Legs.forEach((leg) => {
          if (leg.SeatInfo) {
            leg.SeatInfo = sortByProductId(leg.SeatInfo);
          }
        });
      }
    }

    return sortedProducts;
  } catch (e) {
    console.log("sortProductsAndSeats error", e);
    return products;
  }
};
